module.exports = __webpack_public_path__ + "static/media/10259.d0a915ff.jpg";